import { Box, BoxProps, Flex } from "@chakra-ui/react";
import React from "react";
import { DashboardMenuLink } from "./DashboardMenuLink";
import { managerDashboardMenuItems } from "./managerDashboardMenuItems";

interface SponsorDashboardMenuProps extends BoxProps {
  onItemSelected: () => void;
}

const SponsorDashboardMenu = ({
  onItemSelected,
  ...boxProps
}: SponsorDashboardMenuProps) => (
  <Box
    as="nav"
    pos="fixed"
    top="0"
    left="0"
    h="full"
    pb="10"
    overflowX="hidden"
    overflowY="auto"
    bg="background"
    borderColor="border.gray"
    borderRightWidth="1px"
    w="240px"
    zIndex={"sponsorDashboardMenu"}
    {...boxProps}
  >
    <Flex direction="column" aria-label="Main Navigation" mt={20}>
      {managerDashboardMenuItems.map((item) => (
        <DashboardMenuLink
          key={item.name}
          to={item.to}
          icon={item.icon}
          onClick={onItemSelected}
        >
          {item.children}
        </DashboardMenuLink>
      ))}
    </Flex>
  </Box>
);

export default SponsorDashboardMenu;
